import React from "react";
import PropTypes from "prop-types";

// from https://dev.to/bravemaster619/simplest-way-to-embed-a-youtube-video-in-your-react-app-3bk2

const YoutubeEmbed = ({ embedId }) => (
  <div className="video-responsive">
    <iframe
      width="320"
      height="180"
      src={`https://www.youtube.com/embed/${embedId}?fs=1&autoplay=0`}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      title="Embedded youtube"
    />
  </div>
);

YoutubeEmbed.propTypes = {
  embedId: PropTypes.string.isRequired,
};

export default YoutubeEmbed;
